import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from "components/card";
import SummaryHeader from "components/header/SummaryHeader";
import { FileText } from "lucide-react";
import SearchFilter from "components/search/SearchFilter";
import SelectOption from "components/select/SelectOption";
import LeaveRequestTab from "./components/LeaveRequestTab";
import {
  getLeaveStat, getLeaveList
} from "../../../../redux/leave/leaveState";
import { getLeaveTypeList } from "../../../../redux/optionlist/optionlistState";

const LeaveRequests = ({
  leaveTypeList,
  recordStat,
  getStats,
  getLeaveTypes,
  doSearch,
  pagination,
  filters = {},
}) => {
  const currentType = filters.type_id;

  useEffect(() => {
    getStats();
    getLeaveTypes();
  }, [getStats, getLeaveTypes]);

  const onSearchType = (value) => {
    const data = {
      ...(filters || {}),
      page: 1,
			paginate: pagination?.per_page || 10,
    }

    if (value !== "all") {
      data.type_id = value;
    } else {
      delete data.type_id;
    }

    doSearchHandler(data);
  };

  const doSearchHandler = (data) => {
    doSearch(data);
    getStats(data);
  };

  return (
    <div className="flex flex-col">
      <div className="space-y-6 max-w-[1800px]">
        <SummaryHeader
          title="Leave Request Management"
          icon={FileText}
          description="Review and manage employee leave requests"
          color="green"
          rightNav={
            <div className="flex items-center gap-6 flex-shrink-0">
              <div className="text-right">
                <p className="text-emerald-100/80 text-[12px] mb-1">
                  Pending Requests
                </p>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
                  <p className="text-[28px] font-bold text-white">{recordStat?.pending}</p>
                </div>
              </div>
            </div>
          }
        />

        <Card className="rounded-xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <SearchFilter
              placeholder="Search by name, ID, or position..."
              searchHandler={doSearchHandler} 
              filters={filters} 
              pagination={pagination}
            />
            <SelectOption
              placeholder="All Leave Types"
              options={leaveTypeList}
              value={currentType}
              onChange={(value) => onSearchType(value)}
            />
          </div>
        </Card>

        <LeaveRequestTab />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordStat: state.leave.leaveStat.data,
  leaveTypeList: state.optionlist.leaveTypeList?.items,
  filters: state.leave.leaveList.filters,
});

const mapDispatchToProps = (dispatch) => ({
  getStats: (data) => dispatch(getLeaveStat(data)),
  getLeaveTypes: (data) => dispatch(getLeaveTypeList(data)),
  doSearch: (filters) => dispatch(getLeaveList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveRequests);
